if (!customElements.get('shop-the-look-bundle')) {
  class ShopTheLookBundle extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.addButton = this.querySelector('[data-shop-the-look-add]');
      this.status = this.querySelector('[data-shop-the-look-status]');
      this.total = this.querySelector('[data-shop-the-look-total]');
      this.variantInputs = [...this.querySelectorAll('[data-shop-the-look-variant]')];
      this.closeButtons = [...this.querySelectorAll('[data-shop-the-look-close]')];
      this.openButtons = [...document.querySelectorAll(`[data-shop-the-look-open="${this.id}"]`)];

      this.openButtons.forEach((button) => button.addEventListener('click', () => this.open(button)));
      this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
      this.variantInputs.forEach((input) => input.addEventListener('change', () => this.updatePrice()));
      this.addButton.addEventListener('click', () => this.addAll());
      this.dialog.addEventListener('click', (event) => this.closeOnBackdrop(event));
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('shop-the-look-bundle-open');
        if (this.opener) this.opener.focus();
      });
      this.updatePrice();
    }

    open(button) {
      this.opener = button;
      this.status.textContent = '';
      document.body.classList.add('shop-the-look-bundle-open');
      this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    closeOnBackdrop(event) {
      const bounds = this.dialog.getBoundingClientRect();
      const inDialog = event.clientX >= bounds.left
        && event.clientX <= bounds.right
        && event.clientY >= bounds.top
        && event.clientY <= bounds.bottom;
      if (!inDialog) this.close();
    }

    selectedItems() {
      return this.variantInputs.map((input) => ({
        id: Number(input.value),
        quantity: 1
      }));
    }

    updatePrice() {
      const cents = this.variantInputs.reduce((sum, input) => {
        const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        return sum + Number(option && option.dataset.price ? option.dataset.price : 0);
      }, 0);
      this.total.textContent = this.formatMoney(cents);

      this.variantInputs.forEach((input) => {
        if (input.tagName !== 'SELECT' || !input.value) return;
        const price = input.closest('[data-shop-the-look-product]').querySelector('[data-shop-the-look-price]');
        price.textContent = this.formatMoney(Number(input.selectedOptions[0].dataset.price));
      });
    }

    formatMoney(cents) {
      const format = this.dataset.moneyFormat || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      const amountNoDecimals = Math.round(cents / 100).toString();
      const amountWithComma = amount.replace('.', ',');
      const amountNoDecimalsWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      return format
        .replace(/{{\s*amount_no_decimals_with_comma_separator\s*}}/, amountNoDecimalsWithComma)
        .replace(/{{\s*amount_with_comma_separator\s*}}/, amountWithComma)
        .replace(/{{\s*amount_no_decimals\s*}}/, amountNoDecimals)
        .replace(/{{\s*amount\s*}}/, amount);
    }

    validate() {
      const missing = this.variantInputs.find((input) => !input.value);
      if (!missing) return true;

      this.status.textContent = 'Please select a size for every item.';
      missing.focus();
      missing.reportValidity();
      return false;
    }

    async addAll() {
      if (!this.validate() || this.addButton.getAttribute('aria-disabled') === 'true') return;

      this.setLoading(true);
      const sectionsToUpdate = ['page-header', 'cart-drawer']
        .map((selector) => document.querySelector(selector))
        .filter((element) => element);

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: this.selectedItems(),
            sections: sectionsToUpdate.map((element) => element.dataset.sectionId),
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'The items could not be added.');

        if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
          sectionsToUpdate.forEach((element) => {
            if (typeof element.updateFromCartChange === 'function') {
              element.updateFromCartChange(data.sections[element.dataset.sectionId]);
            }
          });
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        this.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantIds: this.selectedItems().map((item) => item.id) }
        }));

        this.close();
        if (document.querySelector('.template-cart')) {
          const cartForm = document.querySelector('cart-form');
          if (cartForm && cartForm.enableAjaxUpdate) cartForm.refresh();
        } else if (theme.settings.afterAddToCart === 'page') {
          window.location.href = theme.routes.cart;
        } else if (theme.settings.afterAddToCart === 'drawer' && document.querySelector('.js-cart-drawer')) {
          document.querySelector('.js-cart-drawer').open(this.opener || this.addButton);
        } else if (theme.settings.afterAddToCart === 'notification') {
          const template = document.getElementById('AddedNotification');
          if (template) {
            const notification = template.content.firstElementChild.cloneNode(true);
            notification.dataset.productTitle = 'Complete look';
            (document.querySelector('.pageheader--sticky') || document.body).appendChild(notification);
          }
        }
      } catch (error) {
        this.status.textContent = error.message || 'Something went wrong. Please try again.';
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      this.addButton.setAttribute('aria-disabled', loading ? 'true' : 'false');
      this.addButton.classList.toggle('is-loading', loading);
      if (loading) this.status.textContent = 'Adding your complete look…';
    }
  }

  customElements.define('shop-the-look-bundle', ShopTheLookBundle);
}
